module.exports = __webpack_public_path__ + "img/news-image4.e90d6269.png";